/*
	Zwraca rodzaj urządzenia: czy jest to wersja webowa (z rozróżnieniem na desktop / mobile), czy też aplikacjaze sklepu.
	@param includeAppType - dodaj typ aplikacji (Buyer/Seller)
*/
const getDeviceType = (includeAppType:boolean = false) => {
	const { userAgent } = navigator;
	const isIpad = (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) || /iPad/i.test(userAgent);
	const isPhone = /Android|iPhone/i.test(userAgent);
	const isApp = typeof wrapee !== 'undefined';

	let result = (isPhone || isIpad) ? 'WebAppMobile' : 'WebAppDesktop';
	if (!isApp && window.matchMedia('(display-mode: standalone)').matches) {
		result += 'Pwa';
	}

	if (isApp) {
		result = userAgent.indexOf('appstore.oferteo') > -1 ? 'AppleApp' : 'AndroidApp';
		if (includeAppType) {
			result = `${result}-${window.localStorage.getItem('isBuyerApp') === 'true' ? 'BuyerApp' : 'SellerApp'}`;
		}
	}
	return result;
};

const getDeviceData = () => {
	const result = window.matchMedia('(pointer: fine)').matches ? 'desktop' : 'mobile';
	return result;
};

const getUserAgent = () => {
	const result = navigator.userAgent;
	return result;
};

export default getDeviceType;
export { getDeviceType, getDeviceData, getUserAgent };
